import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";

type CollectionSnippetPlacholderProps = {
  type?: "default" | "compact" | "card" | "cardV2" | "cardV3";
  compact?: boolean;
  className?: string;
  expandAnimation?: boolean;
};

const CollectionSnippetPlacholder = ({
  type,
  className,
}: CollectionSnippetPlacholderProps) => {
  if (type === "cardV2") {
    return (
      <div className="flex justify-center">
        <CustomCard
          className={twMerge(
            "w-[184px] h-[144px] p-[10px]",
            "flex flex-col",
            "shadow-lg",
            className
          )}
        >
          <div className="flex-1 w-full md:max-h-max space-y-[4px]">
            <div className="w-full h-[14px] md:h-[22px] bg-[#ccc]"></div>
            <div className="w-[50%] h-[14px] md:h-[22px] bg-[#ccc]"></div>
          </div>
          <div
            className={twMerge(
              "relative",
              "w-[164px] h-[75px]",
              "mt-[5px]",
              "bg-[#ccc]"
            )}
          ></div>
        </CustomCard>
      </div>
    );
  }

  if (type === "cardV3") {
    return (
      <div
        className={twMerge(
          "basis-[calc(50%-15px)] grow animate-pulse",
          className
        )}
      >
        <CustomCard
          className={twMerge("mb-0 p-[15px]", "w-[100%]", "flex items-center")}
        >
          <div className="rounded-[10px] w-[55px] h-[55px] bg-inactive-gray mr-[15px] shadow-md" />
          <div className="">
            <div className="bg-inactive-gray w-[230px] h-[10px] mb-[10px]"></div>
            <div className="bg-inactive-gray w-[100px] h-[10px]"></div>
          </div>
        </CustomCard>
      </div>
    );
  }

  if (type === "card") {
    return (
      <div className="flex justify-center">
        <CustomCard
          className={twMerge(
            "w-[144px] h-[112px] p-[10px]",
            "md:w-[288px] md:h-[216px] md:p-[16px]",
            "flex flex-col",
            "shadow-none",
            "border border-solid border-inactive-gray",

            // animation
            // "animate-pulse",
            // expandAnimation && "duration-500 ease-out transition",
            // expandAnimation && "transform origin-top",
            // expandAnimation && (show ? "scale-y-100" : "scale-y-0"),

            className
          )}
        >
          <div className="flex-1 w-full md:max-h-max space-y-[4px]">
            <div className="w-full h-[14px] md:h-[22px] bg-[#ccc]"></div>
            <div className="w-[50%] h-[14px] md:h-[22px] bg-[#ccc]"></div>
          </div>
          <div
            className={twMerge(
              "relative",
              "w-[124px] h-[55px]",
              "md:w-[256px] md:h-[112px]",
              "mt-[5px]",
              "bg-[#ccc]"
            )}
          ></div>
        </CustomCard>
      </div>
    );
  }

  return null;

  //   if (compact || type === "compact") {
  //     return (
  //       <div
  //         className={twMerge(
  //           "px-[15px] py-[10px]",
  //           "flex items-center",
  //           "space-x-[7px]"
  //         )}
  //       >
  //         <Link href={`/collections/${slug}`}>
  //           <div className={twMerge()}>
  //             <Image
  //               src={small}
  //               alt={name}
  //               width={35}
  //               height={35}
  //               className="rounded-[5px]"
  //             />
  //           </div>
  //         </Link>
  //         <Link
  //           href={`/collections/${slug}`}
  //           className={twMerge("text-active-black", "flex-1 flex items-center")}
  //         >
  //           <div className="text-[14px] font-medium">{name}</div>
  //         </Link>
  //         <FollowCollectionButton collection={collection} style="small" />
  //       </div>
  //     );
  //   }

  //   return (
  //     <div className={twMerge("px-[15px]", "py-[10px]", "overflow-hidden")}>
  //       <Link
  //         className={twMerge(
  //           "relative",
  //           "block",
  //           "group",
  //           "md:w-[270px]",
  //           "h-[98px]",
  //           "overflow-hidden",
  //           "rounded-[15px]"
  //         )}
  //         href={`/collections/${slug}`}
  //       >
  //         <div
  //           className={twMerge(
  //             "absolute",
  //             "bottom-0",
  //             "top-0",
  //             "right-0",
  //             "left-0",
  //             "md:w-[270px]",
  //             "h-[98px]",
  //             "scale-100",
  //             "group-hover:scale-125",
  //             "ease-in",
  //             "duration-200"
  //           )}
  //         >
  //           <Image
  //             src={coverImage}
  //             alt={name}
  //             width={300}
  //             height={98}
  //             layout={"responsive"}
  //             className="rounded-[15px]"
  //           />
  //         </div>
  //         <div
  //           className={twMerge(
  //             "absolute bottom-0 top-0 right-0 left-0 p-[10px] flex flex-col justify-end text-white",
  //             "bg-gradient-to-t from-black to-transparent"
  //           )}
  //         >
  //           <div className="mb-[10px] text-[12px] text-ellipsis">
  //             {description}
  //           </div>
  //           <div className="mb-[5px] text-[18px] font-medium leading-0">
  //             {name}
  //           </div>
  //         </div>
  //       </Link>
  //     </div>
  //   );
};

export default CollectionSnippetPlacholder;
